const apiUrl = process.env.REACT_APP_API_URL;
export const PutJutgeProblemaIdTest = async (id_problema: string, id_test: string, json: any) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/problemes/${id_problema}/test/${id_test}`,
            {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(json)
            });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
